import { mapState } from 'vuex';
import prices from "@/mixins/prices";

export default {
  mixins: [
    prices
  ],
  methods: {
    getRefundableState(v) {
      return v
        ? this.$t("main.room_types.refundable")
        : this.$t("main.room_types.not_refundable");
    },
    // getBreakfastState(v) {
    //   return v
    //     ? this.$t("main.room_types.breakfast_included")
    //     : this.$t("main.room_types.breakfast_excluded");
    // },
  },
  computed: {
    ...mapState({
      properties: state => state.search.dataRequest.data.collection || [],
      isSuggestion: state => !!state.search.dataRequest.data.suggestion,
    }),
    propertiesList() {
      let properties = JSON.parse(JSON.stringify(this.properties));

      return properties.map((property) => {
        const oldAmount = !!property.best_rate && !!property.best_rate.amount ? property.best_rate.amount : 0;
        let discountedAmount = oldAmount;

        if (!!property.best_rate) {
          discountedAmount = this.calculateSinglePrice({
            amount: oldAmount
          }, {
            property,
            skipCoupon: true,
            withRoomTypePromotions: true,
            withBestPropertyPromotion: true,
            roomType: {
              id: property.best_rate.room_type_id
            },
          });
        }

        if (parseFloat(oldAmount) !== parseFloat(discountedAmount)) {
          property.old_amount = oldAmount;
        }

        property.amount = discountedAmount;

        return property;
      })
    }
  },
}
